import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import "./App.css";
import { Helmet } from "react-helmet";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";

function Home() {
  const [loading, setLoading] = useState(false);
  const [viewAllProducts, setViewAllProducts] = useState(true);
  const [viewSelectedProducts, setViewSelectedProducts] = useState(false);
  const [productID, setProductID] = useState(101);
  const [allProducts, setAllProducts] = useState([]);
  const [kbVersions, setKbVersions] = useState([]);
  const [allKbVersions, setAllKbVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState("");
  const [data, setData] = useState({
    productVersionIDs: [],
    productVersionNames: [],
  });
    const [sessionID, setSessionID] = useState(null);




  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  async function fetchAllProducts() {
    const response = await fetch(`/allProducts`);
    const result = await response.json();
    if (Array.isArray(result) && result.length > 0) {
      setAllProducts(result);
    } else {
      setAllProducts([]);
    }
  }
  useEffect(() => {
    fetchAllProducts();
  }, []);

  async function fetchProductVersions() {
    setData({ productVersionIDs: [], productVersionNames: [] });
    const response = await fetch(`/allVersionsByID/${productID}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
      },
    });

    const result = await response.json();
    setData(result);
  }
  async function fetcAllhKbVersions() {
    setKbVersions([]);
    setAllKbVersions([]);
    setLoading(true);
    const response = await fetch(`/allknowledgeBasesByID/${productID}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
      },
    });

    const result = await response.json();
    setLoading(false);
    if (Array.isArray(result) && result.length > 0) {
      setAllKbVersions(result);
    } else {
      setAllKbVersions([]);
    }
  }
  async function fetchKbVersions() {
    setKbVersions([]);
    setLoading(true);
    const response = await fetch(
      `/knowledgeBasesByVersionID/${selectedVersion}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
        },
      }
    );

    const result = await response.json();
    setLoading(false);
    if (Array.isArray(result) && result.length > 0) {
      setKbVersions(result);
    } else {
      setKbVersions([]);
    }
  }

  useEffect(() => {
    fetchProductVersions();
    fetcAllhKbVersions();
  }, [productID]);
  useEffect(() => {
    fetchKbVersions();
  }, [selectedVersion]);
  // const productSetSessionID = (productId) => {
  //   sessionStorage.setItem("productid", productId);
  //   setProductID(productId);
  // };
  const productSetSessionID = (id) => {
    sessionStorage.setItem("productid", id); // optional, for persistence
    setSessionID(id); // for current page highlight
    setProductID(id); // to fetch versions
  };

  
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [globalFilterTwo, setGlobalFilterTwo] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    kbdetail: { value: null, matchMode: allKbVersions.STARTS_WITH },
    kburl: { value: null, matchMode: allKbVersions.STARTS_WITH },
    releasedate: { value: null, matchMode: allKbVersions.STARTS_WITH },
    buildnumber: { value: null, matchMode: allKbVersions.STARTS_WITH },
    fileversion: { value: null, matchMode: allKbVersions.STARTS_WITH },
  });
  const [filtersTwo, setFiltersTwo] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    kbdetail: { value: null, matchMode: kbVersions.STARTS_WITH },
    kburl: { value: null, matchMode: kbVersions.STARTS_WITH },
    releasedate: { value: null, matchMode: kbVersions.STARTS_WITH },
    buildnumber: { value: null, matchMode: kbVersions.STARTS_WITH },
    fileversion: { value: null, matchMode: kbVersions.STARTS_WITH },
  });
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const onGlobalFilterChangeTwo = (e) => {
    const value = e.target.value;
    let _filters = { ...filtersTwo };

    _filters["global"].value = value;

    setFiltersTwo(_filters);
    setGlobalFilterTwo(value);
  };

  const handleMapLink = (rowData) => {
    return (
      <>
        <a
          href={rowData.kburl}
          target="_blank"
          rel="noopener noreferrer"
          className=""
          style={{ textDecoration: "none" }}>
          {rowData.kburl}
        </a>
      </>
    );
  };



  useEffect(() => {
    if (allProducts.length > 0 && !sessionID) {
      const defaultProduct = allProducts[0];
      productSetSessionID(defaultProduct.productid);
      setSelectedVersion("");
      setKbVersions([]);
    }
  }, [allProducts]);


  return (
    <>
      <Helmet>
        <title>Home | Database latest Version </title>
        <meta
          name="description"
          content="Stay up-to-date with database releases, fixes, and updates for Microsoft SQL, MySQL, PostgreSQL, and Oracle Database — all in one place at Clota Technology."
        />
        <meta
          name="keywords"
          content="Database, SQL, MySQL, PostgreSQL, Oracle, Clota Technology, DB Updates, Releases, Fixes"
        />
        <meta name="author" content="Clota Technology" />

        {/* Open Graph (OG) for social media sharing */}
        <meta property="og:title" content="Home | Clota Technology" />
        <meta
          property="og:description"
          content="All your database updates and fixes in one place. Microsoft SQL, MySQL, PostgreSQL, Oracle – Clota Technology has you covered."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clotatechnology.com/" />
        <meta
          property="og:image"
          content="https://www.clotatechnology.com/logo.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Home | Clota Technology" />
        <meta
          name="twitter:description"
          content="Find all database updates and fixes at one place – Clota Technology."
        />
        <meta
          name="twitter:image"
          content="https://www.clotatechnology.com/logo.png"
        />

        {/* Canonical Link */}
        <link rel="canonical" href="https://www.clotatechnology.com/" />
      </Helmet>
      <Divider />
      <div className="fontclass px-5">
        <h1 className="fs-h1 text-center">Welcome To Database Version</h1>

        <div style={{ display: "flex",gap: "0.3rem", justifyContent: "center" }}>
        {allProducts.map((product) => (
         
          <Button
            label={product.productname}
            outlined
            security="info"
            className= {`mb-2 fontclass p-button-${product.productowner.toLowerCase()} ${
              sessionID === product.productid ? "highlight-button" : ""
            }`}
            rounded
            size="small"
            onClick={() => {
              handleScrollTop();
              productSetSessionID(product.productid);
              setSelectedVersion("");
              setKbVersions([]);
            }}
          />
        ))}
        </div>
        <Divider />
        <div>
          <div className="lg:flex lg:justify-content-between">
            <div>
              <Button
                label="All KB Details"
                rounded
                size="small"
                className="mr-2 mb-2 fontclass btn-styles homebutton"
                onClick={() => {
                  fetcAllhKbVersions();
                  setViewAllProducts(true);
                  setViewSelectedProducts(false);
                }}
              />
              <Dropdown
                value={selectedVersion}
                onChange={(e) => {
                  setSelectedVersion(e.value);
                  fetchKbVersions();
                  setViewAllProducts(false);
                  setViewSelectedProducts(true);
                }}
                options={
                  data && data.productVersionNames
                    ? data.productVersionNames.map((selectIdTwo, index) => ({
                        label: selectIdTwo,
                        value: data.productVersionIDs[index],
                      }))
                    : []
                }
                optionLabel="label"
                placeholder="Select Version"
                className="mr-2 mb-2 fontclass "
                scrollHeight="250px"
                virtualScrollerOptions={{ itemSize: 50 }}
                filter
                checkmark={true}
                highlightOnSelect={true}
              />
            </div>
            <div>
              {viewAllProducts && (
                <>
                  <InputText
                    placeholder="Search..."
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    className="fontclass"
                  />
                </>
              )}
              {viewSelectedProducts && (
                <>
                  <InputText
                    placeholder="Search..."
                    value={globalFilterTwo}
                    onChange={onGlobalFilterChangeTwo}
                    className="fontclass"
                  />
                </>
              )}
            </div>
          </div>

          {viewAllProducts && (
            <>
            <div className="shadaw-5">
              <DataTable
                value={allKbVersions}
                className="fontclass"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 30, 500]}
                removableSort
                scrollable
                scrollHeight="420px"
                size="small"
                loading={loading}
                filters={filters}
                globalFilterFields={[
                  "kbdetail",
                  "kburl",
                  "releasedate",
                  "buildnumber",
                  "fileversion",
                ]}>
                <Column
                  field="kbdetail"
                  header="KB Detail"
                  className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="kburl"
                  header="URL"
                  body={handleMapLink}
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="releasedate"
                  header="Release Date"
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="buildnumber"
                  header="Build No"
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="fileversion"
                  header="File Version"
                                    className="fontclass"
                  filter
                  sortable></Column>
              </DataTable>
              </div>
            </>
          )}
          {viewSelectedProducts && (
            <>
            <div className="shadaw-5">
              <DataTable
                value={kbVersions}
                                  className="fontclass"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 30, 500]}
                removableSort
                scrollable
                scrollHeight="420px"
                size="small"
                loading={loading}
                filters={filtersTwo}
                globalFilterFields={[
                  "kbdetail",
                  "kburl",
                  "releasedate",
                  "buildnumber",
                  "fileversion",
                ]}>
                <Column
                  field="kbdetail"
                  header="KB Detail"
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="kburl"
                  header="URL"
                  body={handleMapLink}
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="releasedate"
                  header="Release Date"
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="buildnumber"
                  header="Build No"
                                    className="fontclass"
                  filter
                  sortable></Column>
                <Column
                  field="fileversion"
                  header="File Version"
                                    className="fontclass"
                  filter
                  sortable></Column>
              </DataTable>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Home;
